class ShortcutButtons extends HTMLElement {
  constructor() {
    super();
    this.onPopState = this.onPopState.bind(this);
    this.onCollectionUpdated = this.onCollectionUpdated.bind(this);
  }

  connectedCallback() {
  // Установить состояние сортировки при загрузке
  this.buttons = this.querySelectorAll('.shortcut__button');
  this.setInitialActiveSortButton();

  this.buttons.forEach(button => {
    // Локальный таймаут для дебаунса каждой кнопки
    let debounceTimeout = null;

    button.addEventListener("click", () => {
      const btn = button;
      if (!btn) return;

      // Очистка предыдущего таймаута
      clearTimeout(debounceTimeout);

      // Запускаем обработку с задержкой
      debounceTimeout = setTimeout(() => {
        // Сортировка (кнопки <button>)
        if (btn.matches("[type='button'][value]")) {
          this.handleSortButton(btn);
          return;
        }

        // Фильтр (кнопки с чекбоксами)
        const checkbox = btn.querySelector("input[type='checkbox']");
        if (checkbox) {
          this.handleFilterButton(btn);
        }
      }, 150); // задержка 150мс
    });
  });

  // Назад/вперёд в браузере
  window.addEventListener("popstate", this.onPopState);

  // После AJAX подмены секции
  document.addEventListener("collection:updated", this.onCollectionUpdated);
}


  disconnectedCallback() {
    window.removeEventListener("popstate", this.onPopState);
    document.removeEventListener("collection:updated", this.onCollectionUpdated);
  }

  /*****************************
   *  Обработчики событий
   *****************************/
  onPopState() {
    this.setInitialActiveSortButton();
  }

  onCollectionUpdated() {
    this.setInitialActiveSortButton();
  }

  /*****************************
   *  СОРТИРОВКА
   *****************************/
  handleSortButton(btn) {
    const sortValue = btn.getAttribute("value");
    if (!sortValue) return;

    const url = new URL(window.location.href);
    const isActive = btn.classList.contains("shortcut__button--active");

    if (isActive) {
      // Повторный клик - удалить sort_by
      url.searchParams.delete("sort_by");
      this.clearSortActiveState();
    } else {
      // Установить новый sort_by
      url.searchParams.set("sort_by", sortValue);
      this.updateSortActiveState(btn);
    }

    this.updateURL(url);
  }

  updateSortActiveState(activeBtn) {
    const buttons = this.querySelectorAll(".shortcut__button[type='button'][value]");

    buttons.forEach((btn) => {
      btn.classList.toggle("shortcut__button--active", btn === activeBtn);
    });
  }

  clearSortActiveState() {
    const buttons = this.querySelectorAll(".shortcut__button[type='button'][value]");
    buttons.forEach((btn) => btn.classList.remove("shortcut__button--active"));
  }

  setInitialActiveSortButton() {
    const url = new URL(window.location.href);
    const hasSortBy = url.searchParams.has("sort_by");
    const currentSort = hasSortBy ? url.searchParams.get("sort_by") : null;

    const buttons = this.querySelectorAll(".shortcut__button[type='button'][value]");

    buttons.forEach((btn) => {
      if (currentSort && btn.getAttribute("value") === currentSort) {
        btn.classList.add("shortcut__button--active");
      } else {
        btn.classList.remove("shortcut__button--active");
      }
    });
  }

  /*****************************
   *  ФИЛЬТРЫ
   *****************************/
  handleFilterButton(btn) {
  const input = btn.querySelector("input[type='checkbox']");
  if (!input) return;

  const paramName = input.name;
  const paramValue = input.value;

  const url = new URL(window.location.href);

  // Получаем все текущие значения
  const currentValues = url.searchParams.getAll(paramName);

  if (currentValues.includes(paramValue)) {
    // 🔥 Повторный клик - удаляем параметр полностью
    url.searchParams.delete(paramName);
    input.checked = false;
  } else {
    // Добавляем фильтр
    url.searchParams.set(paramName, paramValue); // set заменяет значение
    input.checked = true;
  }

  // Обновляем коллекцию через AJAX
  console.log('url: ', url);

  this.updateURL(url);
}



  /*****************************
   *  URL + AJAX
   *****************************/
  updateURL(url) {
    history.pushState({}, "", url);
    this.setInitialActiveSortButton();
    this.loadSection(url);
  }

  async loadSection(url) {
    const section = document.querySelector(".shopify-section--main-collection");
    if (!section) return;

    section.classList.add("loading");

    try {
      const response = await fetch(url.toString(), { credentials: "same-origin" });
      const htmlText = await response.text();

      const parser = new DOMParser();
      const htmlDoc = parser.parseFromString(htmlText, "text/html");

      const newSection = htmlDoc.querySelector(".shopify-section--main-collection");
      if (newSection) {
        section.innerHTML = newSection.innerHTML;
        document.dispatchEvent(new CustomEvent("collection:updated"));
      }
    } catch (error) {
      console.error("Shortcut AJAX error:", error);
    } finally {
      section.classList.remove("loading");
    }
  }
}

customElements.define("shortcut-buttons", ShortcutButtons);
